<template functional>
  <svg class="redo-icon" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <filter id="filter1" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="8" />
      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
      <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
      <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
    </filter>
    <g filter="url(#filter1)">
      <path
        d="M72 21.289c0-2.062 2.429-3.164 3.98-1.806l17.956 15.71a2.4 2.4 0 010 3.613L75.98 54.517c-1.551 1.358-3.98.256-3.98-1.806V43H62c-12.15 0-22 9.85-22 22s9.85 22 22 22a6 6 0 010 12c-18.778 0-34-15.222-34-34s15.222-34 34-34h10z"
        fill="#fff"
      />
    </g>
    <path
      clip-rule="evenodd"
      d="M70 21.289c0-3.78 4.452-5.8 7.298-3.311l17.955 15.71a4.4 4.4 0 010 6.623L77.298 56.022c-2.846 2.49-7.298.47-7.298-3.311V45h-8c-11.046 0-20 8.954-20 20s8.954 20 20 20a8 8 0 110 16c-19.882 0-36-16.118-36-36s16.118-36 36-36h8zm5.98-1.806C74.43 18.125 72 19.227 72 21.289V31H62c-18.778 0-34 15.222-34 34s15.222 34 34 34a6 6 0 000-12c-12.15 0-22-9.85-22-22s9.85-22 22-22h10v9.71c0 2.063 2.429 3.165 3.98 1.807l17.956-15.71a2.4 2.4 0 000-3.613z"
      fill="#000"
      fill-opacity=".2"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'RedoIcon',
};
</script>

<style scoped>
.redo-icon {
  height: 100%;
  width: 100%;
}
svg path {
  fill: rgb(206, 212, 218);
}
</style>
